import styled from "styled-components";

export const TooltipContainer = styled.div`
  width: 374px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: ${({ theme }) => theme.modal.bg.tertiary};
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.2);

  .title-wrapper {
    display: flex;
    justify-content: space-between;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    color: ${({ theme }) => theme.button.font.primary};
    background-color: #3485ff;
    padding: 6px 12px;

    .title {
      font-size: 15px;
      font-weight: 500;
    }

    .btn-close {
      padding: 0;
      height: 20px;
      width: 20px;
      outline: none;
    }
  }

  p {
    padding: 5px 8px;
    font-size: 14px;
    margin-bottom: 0;
    color: ${({ theme }) => theme.card.font.tertiary};
  }

  .button-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;

    .steps {
      font-size: 14px;
    }

    .btn-back {
      margin-right: 10px;
    }

    button {
      padding: 0 14px;
      height: 24px;
    }
  }
`;
